import React, { useState, useEffect, useRef } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import logoWhite from '../../8d-logo-white.svg';
import AttendanceReminder from '../AttendanceReminder';
import BirthdayModal from '../BirthdayModal';
import NotificationBell from '../NotificationBell';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import ExportModal from '../ExportModal';
import ReminderSystem, { requestNotificationPermission } from '../ReminderSystem';
import AttendanceFAB from '../AttendanceFAB';
import LatePolicyGate from '../LatePolicy';

const Svg = ({ d, d2 }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d={d}/>{d2&&<path d={d2}/>}
  </svg>
);

const ICONS = {
  dashboard: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22V12h6v10",
  crm:       "M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16 M1 21h22 M9 7h1 M9 11h1 M9 15h1 M14 7h1 M14 11h1 M14 15h1",
  contacts:  "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75",
  documents: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8",
  projects:  "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
  mytasks:   "M9 11l3 3L22 4 M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
  worklog:   "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2 M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2 M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2",
  log:       "M12 5v14 M5 12h14",
  report:    "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8",
  visuals:   "M18 20V10 M12 20V4 M6 20v-6",
  brief:     "M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01",
  perf:      "M12 20V10 M18 20V4 M6 20v-6 M3 3l4 4 4-4 4 4 4-4",
  invoice:   "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M12 18v-6 M9 15h6",
  quote:     "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
  expense:   "M12 2v20 M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6 M3 6l4-4 4 4",
  receivables:"M9 14l6-6 M9 8h.01 M15 14h.01 M3 6h18M3 12h18M3 18h18",
  clock:     "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z M12 6v6l4 2",
  hr_att:    "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z M9 12l2 2 4-4",
  hr_leave:  "M17 12h-5v5h5v-5z M21 3h-1V1h-2v2H5V1H3v2H2C.9 3 0 3.9 0 5v16c0 1.1.9 2 2 2h19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
  hr_hol:    "M20 7H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z M16 3v4 M8 3v4 M2 11h20",
  hr_sal:    "M12 2L2 7l10 5 10-5-10-5z M2 17l10 5 10-5 M2 12l10 5 10-5",
  hr_pay:    "M12 1v22 M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
  hr_slip:   "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M9 15l2 2 4-4",
  hr_emp:    "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75",
  hr_dash:   "M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z",
  hr_reg:    "M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2 M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2 M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2 M12 12h.01 M12 16h.01",
  assets:    "M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-6l-2-2H5a2 2 0 0 0-2 2z",
  settings:  "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  audit:     "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  backup:    "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z M17 21v-8H7v8 M7 3v5h8",
  logout:    "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4 M16 17l5-5-5-5 M21 12H9",
  menu:      "M3 12h18 M3 6h18 M3 18h18",
  bell:      "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9 M13.73 21a2 2 0 0 1-3.46 0",
  caret:     "M9 18l6-6-6-6",
};

function NavItem({ to, icon, label }) {
  return (
    <NavLink to={to} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
      <Svg d={ICONS[icon]} />{label}
    </NavLink>
  );
}

const DEFAULT_EXPANDED = { clients:true, projects:true, reports:true, finance:true, team:true, assets:false, settings:true };

function loadExpanded() {
  try { return { ...DEFAULT_EXPANDED, ...JSON.parse(localStorage.getItem('wt_nav_expanded')||'{}') }; }
  catch { return DEFAULT_EXPANDED; }
}

function NavGroup({ id, emoji, label, expanded, onToggle, children }) {
  return (
    <div className="nav-group">
      <button className="nav-group-btn" onClick={() => onToggle(id)}>
        <span className="nav-group-emoji">{emoji}</span>
        <span className="nav-group-lbl">{label}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
          style={{ flexShrink:0, transition:'transform .18s', transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)', opacity:.5 }}>
          <path d={ICONS.caret}/>
        </svg>
      </button>
      <div className={`nav-group-items ${expanded ? 'open' : ''}`}>{children}</div>
    </div>
  );
}

export default function Layout() {
  const { user, logout, isOwner, isAccountant } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Desktop collapse (mobile uses sidebarOpen's slide-over instead). Remembered per browser;
  // first visit on a narrow laptop screen starts collapsed so the content gets the room.
  const [collapsed, setCollapsed] = useState(() => {
    try {
      const saved = localStorage.getItem('wt_sidebar_collapsed');
      if (saved !== null) return saved === '1';
    } catch {}
    return typeof window !== 'undefined' && window.innerWidth < 1100;
  });
  function toggleSidebar() {
    if (window.innerWidth <= 768) { setSidebarOpen(o => !o); return; }
    setCollapsed(c => {
      try { localStorage.setItem('wt_sidebar_collapsed', c ? '0' : '1'); } catch {}
      return !c;
    });
  }
  const [showReminder, setShowReminder] = useState(false);
  const [reminderText, setReminderText] = useState({ title:'', msg:'' });
  const [bdayModal, setBdayModal] = useState(null);
  const [bdayNotices, setBdayNotices] = useState([]);
  const eveningTimerRef = useRef(null);
  const [expanded, setExpanded] = useState(loadExpanded);
  const [exportModal, setExportModal] = useState(false);

  const isAdmin = user?.role === 'admin';
  const currentMonth = new Date().toISOString().slice(0, 7);

  // Request desktop notification permission once on load
  useEffect(() => { requestNotificationPermission(); }, []);

  function toggleGroup(key) {
    setExpanded(prev => {
      const next = { ...prev, [key]: !prev[key] };
      localStorage.setItem('wt_nav_expanded', JSON.stringify(next));
      return next;
    });
  }

  useEffect(() => {
    const h = new Date().getHours();
    if (isOwner && h >= 18) {
      setReminderText({ title:"Time to review today's work log", msg:"It's past 6:30 PM — check that the team has updated all entries for today." });
      setShowReminder(true);
    } else if (!isOwner && h >= 9 && h < 20) {
      setReminderText({ title:"Remember to log today's work!", msg:"Please update your work entries for today before end of day." });
      setShowReminder(true);
    }
  }, [isOwner]);

  useEffect(() => {
    if (!user) return;
    api.get('/auth/birthday-notices').then(res => {
      const { myBirthday, notices } = res.data;
      setBdayNotices(notices || []);
      if (myBirthday) {
        const today = new Date().toISOString().slice(0,10);
        if (!localStorage.getItem(`bday_morning_${today}`)) setBdayModal('morning');
        const now = new Date();
        const target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 18, 45, 0, 0);
        const msUntil = target.getTime() - now.getTime();
        if (msUntil > 0 && !localStorage.getItem(`bday_evening_${today}`)) {
          eveningTimerRef.current = setTimeout(() => {
            if (!localStorage.getItem(`bday_evening_${today}`)) setBdayModal('evening');
          }, msUntil);
        }
      }
    }).catch(() => {});
    return () => { if (eveningTimerRef.current) clearTimeout(eveningTimerRef.current); };
  }, [user]);

  function dismissBdayModal() {
    const today = new Date().toISOString().slice(0,10);
    localStorage.setItem(bdayModal==='evening' ? `bday_evening_${today}` : `bday_morning_${today}`, '1');
    setBdayModal(null);
  }

  const firstName = user?.name?.split(' ')[0] || 'My';

  return (
    <div className={`app-shell ${collapsed ? 'sb-collapsed' : ''}`}>
      {exportModal && <ExportModal onClose={() => setExportModal(false)} />}
      {bdayModal && <BirthdayModal userName={user?.name} session={bdayModal} onDismiss={dismissBdayModal}/>}
      {!isAccountant && <AttendanceReminder user={user}/>}
      <ReminderSystem />
      {!isAccountant && <AttendanceFAB />}
      {!isOwner && !isAccountant && <LatePolicyGate />}
      {sidebarOpen && <div className="mobile-overlay" onClick={()=>setSidebarOpen(false)}/>}

      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sb-logo-wrap">
          <div className="sb-logo"><img src={logoWhite} alt="8D Studios"/></div>
          <span className="sb-app-name">8D Business OS™</span>
        </div>
        <div className="sb-user">
          <div className="sb-user-name">{user?.name}</div>
          <div className="sb-user-role">
            <span className={isOwner ? 'badge-owner' : isAdmin ? 'badge-admin' : 'badge-team'}>
              {isOwner ? 'Owner' : isAdmin ? 'Admin' : 'Team member'}
            </span>
          </div>
        </div>

        <nav className="nav" onClick={()=>setSidebarOpen(false)}>

          {/* Dashboard — standalone, no group */}
          {!isAccountant && (
            <NavItem to="/" icon="dashboard" label="🏠 Dashboard"/>
          )}

          {/* Clients — owner only */}
          {isOwner && (
            <NavGroup id="clients" emoji="👥" label="Clients" expanded={expanded.clients} onToggle={toggleGroup}>
              <NavItem to="/clients" icon="crm" label="CRM"/>
              <NavItem to="/contacts" icon="contacts" label="Contacts"/>
            </NavGroup>
          )}

          {/* Projects */}
          {!isAccountant && (
            <NavGroup id="projects" emoji="📁" label="Projects" expanded={expanded.projects} onToggle={toggleGroup}>
              <NavItem to="/projects" icon="projects" label="Projects"/>
              {isOwner && <NavItem to="/team-tasks" icon="mytasks" label="Team Task Overview"/>}
              <NavItem to="/my-tasks" icon="mytasks" label={`${firstName}'s Tasks`}/>
              <NavItem to="/worklog" icon="worklog" label="Work Log"/>
              <NavItem to="/log" icon="log" label="Log Work"/>
              {!isOwner && <NavItem to="/performance" icon="perf" label="Performance"/>}
            </NavGroup>
          )}

          {/* Reports — owner only */}
          {isOwner && (
            <NavGroup id="reports" emoji="📊" label="Reports" expanded={expanded.reports} onToggle={toggleGroup}>
              <NavItem to="/report" icon="report" label="Monthly"/>
              <NavItem to="/visuals" icon="visuals" label="Visuals"/>
              <NavItem to="/daily-brief" icon="brief" label="Daily Brief"/>
              <NavItem to="/performance" icon="perf" label="Performance"/>
              <button className="nav-link nav-link-btn" style={{width:'100%',textAlign:'left',cursor:'pointer'}}
                onClick={() => setExportModal(true)}>
                <Svg d={ICONS.report}/> Export Excel
              </button>
            </NavGroup>
          )}

          {/* Finance */}
          {(isOwner || isAccountant) && (
            <NavGroup id="finance" emoji="💰" label="Finance" expanded={expanded.finance} onToggle={toggleGroup}>
              <NavItem to="/invoices" icon="invoice" label="Invoices"/>
              <NavItem to="/quotations" icon="quote" label="Quotations"/>
              {(isOwner || isAccountant) && <NavItem to="/receivables" icon="receivables" label="Receivables"/>}
              {(isOwner || isAccountant) && <NavItem to="/expenses" icon="expense" label="Expenses & P&L"/>}
            </NavGroup>
          )}

          {/* Team */}
          {!isAccountant && (
            <NavGroup id="team" emoji="👨‍💼" label="Team" expanded={expanded.team} onToggle={toggleGroup}>
              <NavItem to="/attendance-clock" icon="clock" label="Clock In / Out"/>
              <NavItem to="/timeline" icon="clock" label="Daily Timeline"/>
              <NavItem to="/hr/attendance" icon="hr_att" label="Attendance"/>
              {(isOwner||isAdmin) && <NavItem to="/hr/register" icon="hr_reg" label="Register"/>}
              <NavItem to="/hr/leaves" icon="hr_leave" label="Leave"/>
              <NavItem to="/hr/holidays" icon="hr_hol" label="Holidays"/>
              {(isOwner||isAdmin) && <>
                <NavItem to="/hr/dashboard" icon="hr_dash" label="HR Dashboard"/>
                <NavItem to="/hr/employees" icon="hr_emp" label="Employees"/>
                <NavItem to="/hr/salary" icon="hr_sal" label="Salary Structures"/>
                <NavItem to="/hr/payroll" icon="hr_pay" label="Payroll"/>
              </>}
              <NavItem to="/hr/payslips" icon="hr_slip" label="My Payslips"/>
            </NavGroup>
          )}

          {/* Assets */}
          {!isAccountant && (
            <NavGroup id="assets" emoji="📂" label="Assets" expanded={expanded.assets} onToggle={toggleGroup}>
              <NavItem to="/assets" icon="assets" label="Asset Library"/>
            </NavGroup>
          )}

          {/* Settings — owner only */}
          {isOwner && (
            <NavGroup id="settings" emoji="⚙️" label="Settings" expanded={expanded.settings} onToggle={toggleGroup}>
              <NavItem to="/settings/business"    icon="settings" label="Business & GST"/>
              <NavItem to="/settings/categories"  icon="settings" label="Categories & Pricing"/>
              <NavItem to="/settings/corrections" icon="settings" label="Correction Types"/>
              <NavItem to="/settings/team"        icon="settings" label="Team Accounts"/>
              <NavItem to="/catalogue" icon="worklog" label="Service Catalogue"/>
              <NavItem to="/proofs" icon="assets" label="Proof Images"/>
              <NavItem to="/audit" icon="audit" label="Audit Log"/>
              <NavItem to="/backup" icon="backup" label="Backup & Recovery"/>
            </NavGroup>
          )}

        </nav>

        <div className="sb-footer">
          <button onClick={()=>{ logout(); navigate('/login'); }}>
            <Svg d={ICONS.logout}/> Sign out
          </button>
        </div>
      </aside>

      <div className="main">
        <div className="topbar">
          <div style={{display:'flex',alignItems:'center',gap:12}}>
            <button className="btn-ghost hamburger" onClick={toggleSidebar} title={collapsed ? 'Show menu' : 'Hide menu'} aria-label="Toggle menu">
              <Svg d={ICONS.menu}/>
            </button>
            <span className="live-dot"/> <span style={{fontSize:11,color:'var(--text2)'}}>Live</span>
          </div>
          <div className="topbar-right" style={{display:'flex',alignItems:'center',gap:8}}>
            <NotificationBell/>
            <select id="globalMonth" defaultValue={currentMonth} style={{fontSize:12}}
              onChange={e=>window.dispatchEvent(new CustomEvent('monthChange',{detail:e.target.value}))}>
              {Array.from({length:8},(_,i)=>{
                const now=new Date();
                const totalMonths=now.getFullYear()*12+now.getMonth()-i;
                const y=Math.floor(totalMonths/12), m=totalMonths%12; // m is 0-indexed
                const v=`${y}-${String(m+1).padStart(2,'0')}`;
                return <option key={v} value={v}>{new Date(y,m,1).toLocaleString('default',{month:'long',year:'numeric'})}</option>;
              })}
            </select>
          </div>
        </div>

        <div className="content">
          {showReminder && (
            <div className="reminder">
              <Svg d={ICONS.bell}/>
              <div style={{flex:1}}>
                <strong>{reminderText.title}</strong>
                <div style={{fontSize:12,color:'var(--text2)',marginTop:2}}>{reminderText.msg}</div>
              </div>
              <button className="btn-ghost btn-sm" onClick={()=>setShowReminder(false)}>✕</button>
            </div>
          )}
          {bdayNotices.map(n=>(
            <div key={n.id} className="reminder" style={{background:'#fff8f0',borderColor:'#FF0033'}}>
              <span style={{fontSize:20,lineHeight:1}}>🎂</span>
              <div style={{flex:1}}>
                <strong style={{color:'#073E81'}}>
                  {n.daysUntil===0 ? `Today is ${n.name}'s birthday!` : n.daysUntil===1 ? `${n.name}'s birthday is tomorrow` : `${n.name}'s birthday is in ${n.daysUntil} days`}
                </strong>
                <div style={{fontSize:12,color:'var(--text2)',marginTop:2}}>
                  {n.daysUntil===0 ? 'Take a moment to wish them today!' : 'Plan ahead — time to organise something special!'}
                </div>
              </div>
            </div>
          ))}
          <Outlet/>
        </div>
      </div>
    </div>
  );
}
